// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles__heading___2n20j","noRecipients":"styles__noRecipients___3jhqN"};